// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"349":"c44dea10","791":"4ae53988"}[chunkId] + ".js";
};